import {
  FETCH_TRANSACTIONS_REQUEST,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTIONS_FAILURE,
} from '../constants/transactionConstants';

const initialState = {
  data: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
};

const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSACTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.response || [],
        pagination: {
          totalPages: action.payload.pagination?.totalPages || 0,
          totalItems: action.payload.pagination?.totalItems || 0,
          itemsPerPage: action.payload.pagination?.itemsPerPage || 10,
          currentPage: action.payload.pagination?.currentPage || 1,
        },
        error: null,
      };
    case FETCH_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: [],
      };
    default:
      return state;
  }
};

export default transactionReducer;